/* eslint-disable no-multi-assign */
export function openChosen() {
  this.variables({
    chosen: this.getChosenKey()
  }).changed((changes, prev) => {
    this.call('canvasFade', true)
    const useAnimations = this.getUserSettings('useAnimations')
    const noPrevious = !prev.chosen

    this.call('toggleChosenNavbar')

    if (noPrevious && useAnimations) {
      this.call('setChosenInitialPositions')
    }

    this.getChosenScene().update()
  })
}

export function toggleChosenNavbar() {
  if (this.getChosenKey()) {
    this.getChosenSceneNavbar().setNodeStyles({
      display: 'flex'
    })
    this.getEditorPanels().ComponentEditor.EditNavbar.setNodeStyles({
      display: 'none'
    })
  } else {
    this.getChosenSceneNavbar().setNodeStyles({ display: 'none' })
    this.getEditorPanels().ComponentEditor.EditNavbar.setNodeStyles({
      display: 'flex'
    })
  }
}

export function closeChosen() {
  const { isVersionsOpen } = this.getRootState()

  this.call('canvasFade', false)

  this.getChosenViewSvitcher().setNodeStyles({
    transitionProperty: 'none',
    opacity: 0
  })

  this.call('toggleChosenNavbar')

  this.data.loaded = null

  if (!isVersionsOpen) {
    this.getRootState().isFullscreen = false
  }
}

export function adjustChosenFrameSize() {
  const scope = this.getCanvasScope()
  const {
    explorer: explorerInChosenPosChanged,
    selected: selectedPosChanged,
    editorActive
  } = scope

  this.variables({
    editorActive,
    explorerInChosenPosChanged,
    selectedPosChanged
  }).changed(() => {
    const t = setTimeout(() => {
      let left = 'var(--canvas-gutter)'
      if (this.call('isString', explorerInChosenPosChanged)) {
        const dynamicIslandElementRect =
          this.getDynamicIsland().node.getBoundingClientRect()
        // const width = this.getDynamicIsland().node.scrollWidth
        left = `calc(var(--canvas-gutter) + ${dynamicIslandElementRect.left + dynamicIslandElementRect.width}px)`
      } else if (editorActive) {
        const quickEditorRect =
          this.getQuickEditor().node.getBoundingClientRect()
        // const width = this.getDynamicIsland().node.scrollWidth
        left = `calc(var(--canvas-gutter) + ${quickEditorRect.left + quickEditorRect.width}px)`
      }
      this.getChosenElement().setNodeStyles({
        left
      })
      clearTimeout(t)
    }, 250)
  })
}

export function adjustMainWindow() {
  const isFullscreenEditorPanels = this.getRootState('isFullscreen')

  const s = this.state

  const data = this.getCanvasScope()
  // if (!data) return

  const {
    docs,
    fiddle,
    componentEditor,
    explorer: explorerInChosen,
    library,
    designSystem,
    selected,
    activeFunction,
    activeState,
    activeDs
  } = data

  const isCodeViewerActive =
    (selected && componentEditor) || activeFunction || activeState || activeDs

  const selectedInChosen = this.getSelectedKey()
  const chosenInChosen = this.getChosenKey()

  this.variables({
    selectedInChosen,
    chosenInChosen,
    isFullscreenEditorPanels,
    docs,
    fiddle,
    library,
    designSystem,
    explorerInChosen,
    componentEditor,
    activeFunction,
    activeState,
    activeDs,
    isCodeViewerActive
  }).changed(async (changes) => {
    if (isCodeViewerActive) {
      this.getEditorPanels().setNodeStyles({
        display: 'flex'
      })
    } else {
      this.getEditorPanels().setNodeStyles({
        display: 'none'
      })
    }

    const selectedHasChanged = Object.hasOwn(changes, 'selectedInChosen')
    if (selectedHasChanged) {
      data.hoverLayer = null
      data.activeLayer = null
      if (selectedInChosen) {
        const componentState = this.call(
          'deepClone',
          this.getSelected().state.parse()
        )
        // console.log(componentState)
        await s.set(componentState, {
          preventStateUpdateListener: true,
          forceMonacoUpdate: true
        })
      } else if (!selectedInChosen) {
        if (s.value) {
          delete s.code
          await s.remove('value', {
            preventStateUpdateListener: true,
            forceMonacoUpdate: false
          })
        }
      }

      const autoscroll = this.getUserSettings('explorerAutoscroll')
      if (autoscroll && explorerInChosen) {
        await this.call('rerenderFileSidebarByType', 'components')
        await this.call('rerenderFileSidebarByType', 'pages')
      }
    }

    const codeEditorHasChanged = Object.hasOwn(changes, 'isCodeViewerActive')
    if (selectedHasChanged || codeEditorHasChanged) {
      if (isCodeViewerActive) {
        this.getComponentEditor().parent.setNodeStyles({ display: 'flex' })
        this.getComponentEditor().setNodeStyles({ display: 'flex' })
        if (codeEditorHasChanged && !selectedHasChanged)
          this.getComponentEditor().update()
        window.requestAnimationFrame(() => {
          this.changeCodePriority('component', this)
        })
      } else {
        this.getComponentEditor().parent.setNodeStyles({ display: 'none' })
        this.getComponentEditor().setNodeStyles({ display: 'none' })
      }
    }
  })
}

export function setChosenInitialPositions() {
  const data = this.getCanvasScope()
  const { positions, chosen } = data

  const { scale } = positions
  const ChosenElem = chosen?.Flex || chosen
  if (!ChosenElem.node) return

  const rect = ChosenElem.node.getBoundingClientRect()

  const ChosenScene = this.getChosenScene()
  const chosenScenePos = ChosenScene.node.getBoundingClientRect()
  const ViewSvitcher = ChosenScene.ViewSvitcher

  // Calculate the position relative to ChosenScene
  const relLeft = rect.left - chosenScenePos.left + ChosenScene.node.scrollLeft
  const relTop = rect.top - chosenScenePos.top + ChosenScene.node.scrollTop

  const unscaledWidth = rect.width / scale
  const unscaledHeight = rect.height / scale

  // When scaling from center, the top-left corner shifts by:
  // (unscaled_dimension * (scale - 1)) / 2
  // We need to compensate by moving the element back
  const offsetX = (unscaledWidth * (scale - 1)) / 2
  const offsetY = (unscaledHeight * (scale - 1)) / 2

  const left = relLeft + offsetX
  const top = relTop + offsetY
  const right = left + unscaledWidth
  const bottom = top + unscaledHeight

  ViewSvitcher.setNodeStyles({
    opacity: 1,
    transitionProperty: 'none',
    transform: `translate3d(0, 0, 1px) scale(${scale})`,
    inset: `${top}px ${ChosenScene.node.offsetWidth - right}px ${ChosenScene.node.offsetHeight - bottom}px ${left}px`
  })
}

export function adjustChosenAfterOpen() {
  const { data } = this

  window.requestAnimationFrame(() => {
    this.getChosenScene().ViewSvitcher.setNodeStyles({
      transform: 'translate3d(0, 0, 1px)',
      transitionProperty: 'transform, inset',
      position: 'absolute',
      opacity: 1,
      inset: '0',
      width: 'auto',
      height: 'auto'
    })

    window.requestAnimationFrame(() => {
      this.getChosenSceneNavbar().update()
    })
  })

  data.loaded = true
}

export function adjustResponsive() {
  const { previewSize } = this.getCanvasScope()
  const ChosenScene = this.getChosenScene()
  const { ComponentFrameCanvas } = ChosenScene.ViewSvitcher

  const isUnset = previewSize === 'unset'
  const isResizable = previewSize === 'resizable'
  const isCustom = previewSize === 'custom'
  const isAllDevices = previewSize === 'canvas'

  this.variables({ previewSize }).changed((changes, prev) => {
    const wasResizable = prev.previewSize === 'resizable'
    const wasCustom = prev.previewSize === 'custom'
    const wasAllDevices = prev.previewSize === 'canvas'

    ComponentFrameCanvas.setNodeStyles({
      transitionProperty:
        'transform, max-width, max-height, left, top, right, width, height'
    })

    const t = setTimeout(() => {
      ComponentFrameCanvas.setNodeStyles({
        transitionProperty: 'transform, max-width, max-height, left, top, right'
      })
      clearTimeout(t)
    }, 350)

    if (isCustom || wasCustom || isAllDevices || wasAllDevices) {
      const t2 = setTimeout(() => {
        ChosenScene.ViewSvitcher.removeContent()
        ChosenScene.ViewSvitcher.set(
          ChosenScene.ViewSvitcher.data.content(this, this.state, this.context)
        )
        clearTimeout(t2)
      }, 65)
    }

    if (isAllDevices) {
      const breakpoint = this.context.designSystem.DEVICES.mobileM
      const [widthVal] = breakpoint
      const maxWidth = `${widthVal}px`
      ComponentFrameCanvas.setNodeStyles({
        ...ComponentFrameCanvas.props['.isAllDevices'],
        maxWidth,
        maxHeight: '100%'
      })
      const t2 = setTimeout(() => {
        if (ChosenScene.ViewSvitcher) {
          ChosenScene.ViewSvitcher.node.scrollBy(3600, 0)
        }
        clearTimeout(t2)
      }, 65)
      // this.setNodeStyles({
      //   content: {}
      // })
    } else if (wasAllDevices) {
      // this.setNodeStyles({
      //   content: {
      //   }
      // })
      ComponentFrameCanvas.setNodeStyles({
        ...ComponentFrameCanvas.props['!isAllDevices']
      })
    }

    if (isResizable) {
      ComponentFrameCanvas.setNodeStyles({
        ...ComponentFrameCanvas.props['.isResizable']
      })
    } else if (wasResizable) {
      ComponentFrameCanvas.setNodeStyles({
        // height: '100%',
        ...ComponentFrameCanvas.props['!isResizable']
      })
    }

    if (isCustom) {
      ComponentFrameCanvas.setNodeStyles({
        ...ComponentFrameCanvas.props['.isResponsiveMode']
      })
    } else if (wasCustom) {
      ComponentFrameCanvas.setNodeStyles({
        ...ComponentFrameCanvas.props['!isResponsiveMode']
      })
    }

    if (isUnset || !previewSize) {
      ComponentFrameCanvas.setNodeStyles({
        width: '100%',
        height: '100%',
        maxWidth: '100%',
        maxHeight: '100%'
      })
    } else if (!isAllDevices && !isResizable && !isCustom) {
      const { DEVICES } = this.context && this.context.designSystem
      const breakpoint = DEVICES[previewSize]
      const [width, height] = breakpoint
      const maxWidth = width ? `${width}px` : '100%'
      ComponentFrameCanvas.setNodeStyles({
        width: '100%',
        height: `${height}px`,
        maxWidth
      })
    }
  })

  const responsiveState = ChosenScene.ViewSvitcher.content?.state
  const responsiveSize = responsiveState?.previewSize

  if (isCustom) {
    this.variables({ responsiveSize }).changed(() => {
      const devices = this.context.designSystem.DEVICES
      const breakpoint = devices[responsiveSize]

      if (breakpoint) {
        const [widthVal, HeightVal] = breakpoint
        const maxWidth = `calc(${`${widthVal}px`} - 1.8em)`
        const maxHeight = `calc(${`${HeightVal}px`} - 5em)`
        ComponentFrameCanvas.setNodeStyles({
          maxWidth,
          maxHeight
        })
      } else {
        ComponentFrameCanvas.setNodeStyles({
          maxWidth: '100%',
          maxHeight: '100%'
        })
      }
    })
  }
}
